<template>
    <div class="people-container">
        <div class="date" v-if="date">
            {{ date }}
        </div>
        <div class="filters">
            <div class="search">
                <input
                    type="search"
                    v-model="filters.search"
                    placeholder="Search by name, company name, job title, industry or announcement type"
                />
            </div>
            <div class="date-search">
                <div>
                    <label for="cateogries">Start Date:</label>
                    <input type="date" v-model="filters.start_date" :max="filters.end_date" />
                </div>
                <div>
                    <label for="cateogries">End Date:</label>
                    <input type="date" v-model="filters.end_date" :min="filters.start_date" />
                </div>
            </div>
            <div class="filter-category">
                <label for="cateogries">Filter by Industry:</label>
                <select v-model="filters.category">
                    <option selected value="">All</option>
                    <option v-for="category in categories" v-bind:key="category.id" :value="category.id">{{ category.name }}</option>
                </select>
            </div>
            <div class="filter-type">
                <label>Filter by Announcement:</label>
                <select v-model="filters.announcement_type">
                    <option selected value="">All</option>
                    <option v-for="announcement in announcements" v-bind:key="announcement.id" :value="announcement.id">
                        {{ announcement.name }}
                    </option>
                </select>
            </div>
            <div class="sort">
                <label>Sort by:</label>
                <select v-model="filters.sort">
                    <option selected value="last_name,ASC">Last Name A-Z</option>
                    <option selected value="last_name,DESC">Last Name Z-A</option>
                    <option selected value="company_name,ASC">Company Name A-Z</option>
                    <option selected value="company_name,DESC">Company Name Z-A</option>
                    <option selected value="title,ASC">Title A-Z</option>
                    <option selected value="title,DESC">Title Z-A</option>
                </select>
            </div>
        </div>
        <div class="featured" v-show="show && people.featured.length > 0">
            <div class="featured-cards flexslider">
                <ul class="slides">
                    <li
                        class="ibjp-card"
                        :data-id="person.id"
                        :class="slugify(person.category.name)"
                        v-for="person in people.featured"
                        v-bind:key="person.id"
                    >
                        <div class="card-container">
                            <div class="meta">
                                <div class="category">{{ person.category.name }}</div>
                                <div class="photo">
                                    <img
                                        :src="getImageURL(person.cropped_image)"
                                        :alt="person.first_name + ' ' + person.last_name"
                                        loading="lazy"
                                    />
                                </div>
                                <div class="name">{{ person.first_name }} {{ person.last_name }}</div>
                                <div class="company-logo" v-if="person.modified_logo && person.modified_logo != ''">
                                    <a :href="person.website_url" target="_blank">
                                        <img :src="getImageURL(person.modified_logo)" :alt="person.company_name" loading="lazy" />
                                    </a>
                                </div>
                                <div class="company">
                                    <a :href="person.website_url" target="_blank">{{ person.company_name }}</a>
                                </div>
                                <p class="company-description" v-if="person.company_description != ''">{{ person.company_description }}</p>
                            </div>
                            <div class="description">
                                <div class="announcement">{{ person.announcement_type.name }}</div>
                                <div class="title">{{ person.title }}</div>
                                <p>{{ person.description }}</p>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="loader" v-if="loading">
            <img src="@/assets/oval-dark.svg" />
        </div>
        <div id="js-standard" class="standard">
            <div
                class="ibjp-card"
                :data-id="person.id"
                :class="slugify(person.category.name)"
                v-for="person in people.standard"
                v-bind:key="person.id"
            >
                <div class="card-padding">
                    <div class="category">{{ person.category.name }}</div>
                    <div class="photo">
                        <img :src="getImageURL(person.cropped_image)" :alt="person.first_name + ' ' + person.last_name" loading="lazy" />
                    </div>
                    <div class="name">{{ person.first_name }} {{ person.last_name }}</div>
                    <div class="description">
                        <p>{{ person.description }}</p>
                    </div>
                    <div class="company">{{ person.company_name }}</div>
                </div>
                <div class="meta">
                    <div class="announcement">{{ person.announcement_type.name }}</div>
                    <div class="title">{{ person.title }}</div>
                </div>
            </div>
        </div>
        <div class="text-center" v-if="!loading && people.standard.length === 0 && people.featured.length === 0">
            <p>No one was found. Please try a new search.</p>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import { useRoute } from "vue-router";
import moment from "moment";

export default {
    name: "PeopleView",
    components: {},
    data() {
        return {
            date: null,
            people: {
                featured: [],
                standard: [],
            },
            urls: {
                people: ibj_people_api_url + "api/accounts/" + ibj_people_account + "/people",
                categories: ibj_people_api_url + "api/categories",
                announcements: ibj_people_api_url + "api/announcements",
            },
            default_urls: {
                people: ibj_people_api_url + "api/accounts/" + ibj_people_account + "/people",
            },
            latest_urls: {
                people: null,
            },
            current_page: 1,
            last_page: 2,
            loading: false,
            show: false,
            slide: {
                current: null,
                counter: 2,
            },
            filters: {
                search: "",
                category: "",
                announcement_type: "",
                sort: "last_name,ASC",
                issue_date: null,
                people_id: null,
                start_date: null,
                end_date: null,
            },
            people_id_init: false,
            timeout: undefined,
            categories: [],
            announcements: [],
        };
    },
    created() {
        this.getCategories();
        this.getAnnouncements();

        for (var i in this.$route.query) {
            if (this.filters.hasOwnProperty(i)) {
                this.buildURLWithQuery();
                break;
            }
        }

        this.getPeople();

        window.addEventListener("scroll", this.handleScroll);
    },
    mounted() {},
    destroyed() {
        window.removeEventListener("scroll", this.handleScroll);
    },
    watch: {
        "$route.query"() {
            this.resetPeople();
            this.buildURLWithQuery();
            this.getPeople();
        },
        "filters.search": {
            handler(val) {
                var vue = this;

                if (vue.filters.search.length === 0 || vue.filters.search.length >= 3) {
                    clearTimeout(vue.timeout);

                    vue.timeout = setTimeout(function () {
                        vue.updateQueryParams();
                    }, 800);
                }
            },
            deep: true,
        },
        "filters.start_date": {
            handler(val) {
                this.updateQueryParams();
            },
            deep: true,
        },
        "filters.end_date": {
            handler(val) {
                this.updateQueryParams();
            },
            deep: true,
        },
        "filters.category": {
            handler(val) {
                this.updateQueryParams();
            },
            deep: true,
        },
        "filters.announcement_type": {
            handler(val) {
                this.updateQueryParams();
            },
            deep: true,
        },
        "filters.sort": {
            handler(val) {
                this.updateQueryParams();
            },
            deep: true,
        },
        "people.standard": {
            handler(val) {
                window.addEventListener("scroll", this.handleScroll);
            },
            deep: true,
        },
        "people.featured": {
            handler(val) {
                var vue = this;

                jQuery(".featured-cards").removeData("flexslider");

                setTimeout(function () {
                    var current_slide;
                    jQuery(".featured-cards").flexslider({
                        animation: "slide",
                        animationLoop: false,
                        itemWidth: 660,
                        itemMargin: 0,
                        slideshow: false,
                        directionNav: true,
                        controlNav: false,
                        before: function (slider) {
                            vue.slide.current = slider.currentSlide;
                        },
                        after: function (slider) {
                            if (vue.slide.current < slider.currentSlide) {
                                vue.slide.counter--;

                                if (vue.slide.counter === 0) {
                                    vue.getPeople();
                                    vue.slide.current = slider.currentSlide;
                                    vue.slide.counter = 2;
                                }
                            }
                        },
                    });

                    if (vue.slide.current) {
                        var animationSpeed = jQuery(".featured-cards").data("flexslider").vars.animationSpeed;
                        jQuery(".featured-cards").data("flexslider").vars.animationSpeed = 0;
                        jQuery(".featured-cards").data("flexslider").flexAnimate(vue.slide.current);
                        jQuery(".featured-cards").data("flexslider").vars.animationSpeed = animationSpeed;
                    }

                    if (vue.people.featured.length < 2) {
                        var next = document.querySelector(".flex-next");
                        if (next) {
                            next.style.display = "none";
                        }
                    }

                    vue.show = true;
                }, 1);
            },
            deep: true,
        },
    },
    methods: {
        getImageURL(image) {
            if (!image) {
                return image;
            }

            if (image.includes("http")) {
                return image;
            }

            return ibj_people_api_url.slice(0, -1) + image;
        },
        getPeople() {
            var vue = this;

            if (vue.loading) {
                return;
            }

            vue.loading = true;

            vue.latest_urls.people = vue.urls.people;

            if (vue.current_page < vue.last_page) {
                axios
                    .get(vue.urls.people)
                    .then(function (response) {
                        let people = response.data.people.data;

                        people.forEach((person) => {
                            let type = "standard";

                            person.schedules.forEach((schedule) => {
                                if (schedule.product.submission_type_id == 2 || schedule.product.submission_type_id == 3) {
                                    type = "featured";
                                }
                            });

                            if (type == "featured") {
                                vue.people.featured.push(person);
                            } else {
                                vue.people.standard.push(person);
                            }
                        });

                        //vue.people.standard.push(...response.data.people.data);
                        vue.urls.people = response.data.people.next_page_url;
                        vue.current_page = response.data.people.current_page;
                        vue.last_page = response.data.people.last_page;
                        vue.date =
                            moment(response.data.issue.start_date).format("LL") + " - " + moment(response.data.issue.end_date).format("LL");
                        vue.scrollToPerson();
                    })
                    .catch(function (error) {
                        console.log(error);
                    })
                    .then(function () {
                        vue.loading = false;
                    });
            } else {
                vue.loading = false;
            }
        },
        getCategories() {
            var vue = this;

            axios
                .get(vue.urls.categories)
                .then(function (response) {
                    vue.categories = response.data.categories;
                })
                .catch(function (error) {
                    console.log(error);
                })
                .then(function () {});
        },
        getAnnouncements() {
            var vue = this;

            axios
                .get(vue.urls.announcements)
                .then(function (response) {
                    vue.announcements = response.data.announcements;
                })
                .catch(function (error) {
                    console.log(error);
                })
                .then(function () {});
        },
        slugify(string) {
            string = string.replace(/^\s+|\s+$/g, "");

            string = string.toLowerCase();

            var from = "ÁÄÂÀÃÅČÇĆĎÉĚËÈÊẼĔȆÍÌÎÏŇÑÓÖÒÔÕØŘŔŠŤÚŮÜÙÛÝŸŽáäâàãåčçćďéěëèêẽĕȇíìîïňñóöòôõøðřŕšťúůüùûýÿžþÞĐđßÆa·/_,:;";
            var to = "AAAAAACCCDEEEEEEEEIIIINNOOOOOORRSTUUUUUYYZaaaaaacccdeeeeeeeeiiiinnooooooorrstuuuuuyyzbBDdBAa------";
            for (var i = 0, l = from.length; i < l; i++) {
                string = string.replace(new RegExp(from.charAt(i), "g"), to.charAt(i));
            }

            string = string
                .replace(/[^a-z0-9 -]/g, "")
                .replace(/\s+/g, "-")
                .replace(/-+/g, "-");

            return string;
        },
        handleScroll(event) {
            var container = document.getElementById("js-standard");

            if (container.getBoundingClientRect().bottom <= window.innerHeight) {
                window.removeEventListener("scroll", this.handleScroll);
                this.getPeople();
            }
        },
        buildURLWithQuery() {
            var vue = this;
            var separator = "?";
            for (var i in vue.$route.query) {
                if (vue.filters.hasOwnProperty(i)) {
                    vue.urls.people = vue.urls.people + separator + i + "=" + vue.$route.query[i];
                    separator = "&";
                }

                if (i === "search") {
                    var start_date = vue.filters.start_date ?? "2014-01-01";
                    vue.urls.people = vue.urls.people + "&start_date=" + start_date;
                }

                if (i === "people_id") {
                    vue.filters.people_id = vue.$route.query[i];
                }
            }
        },
        updateQueryParams() {
            var filters = {};

            for (var i in this.filters) {
                if (this.filters[i]) {
                    filters[i] = this.filters[i];
                }
            }

            this.$router.push({ path: "/", query: filters });
        },
        resetPeople(type) {
            this.slide.current = null;
            this.people.featured = [];
            this.people.standard = [];
            this.urls.people = this.default_urls.people;
            this.current_page = 1;
            this.last_page = 2;
        },
        scrollToPerson() {
            if (this.people_id_init) {
                return;
            }

            if (this.$route.query["people_id"]) {
                setTimeout(() => {
                    if (document.querySelector("[data-id='" + this.$route.query["people_id"] + "']")) {
                        document.querySelector("[data-id='" + this.$route.query["people_id"] + "']").scrollIntoView({
                            behavior: "smooth",
                            block: "center",
                        });
                    }

                    this.people_id_init = true;
                }, 800);
            }
        },
    },
};
</script>

<style lang="scss">
.people-container {
    * {
        font-family: "Inter", sans-serif;
        box-sizing: border-box;
    }

    .text-center {
        text-align: center;
        margin: auto;
    }

    .loader {
        width: 50px;
        height: 50px;
        margin: auto;

        img {
            width: 100%;
        }
    }

    .date {
        max-width: 1370px;
        width: 100%;
        margin: 0 auto 20px auto;
        text-align: center;
        padding: 0 35px;
        font-size: 18px;
        color: #6e6e6e;
    }

    .filters {
        max-width: 1370px;
        width: 100%;
        margin: auto;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        padding: 0 35px;

        label {
            color: #848484;
            font-size: 14px;
            margin-right: 12px;
            margin-bottom: 6px;
        }

        input[type="search"],
        input[type="date"] {
            width: 100%;
            padding: 12px;
            border-radius: 6px;
            border: solid 1px #d1d5db;
            background: transparent;
        }

        select {
            padding: 12px;
            border-radius: 6px;
            border: solid 1px #d1d5db;
            height: auto;
            background: transparent;
            width: 100%;
        }

        .search {
            width: 100%;
            margin-bottom: 20px;
        }

        .date-search {
            width: 100%;
            margin-bottom: 20px;
            display: flex;
            flex-wrap: wrap;
            gap: 20px;

            div {
                width: calc(50% - 10px);

                @media only screen and (max-width: 659px) {
                    width: 100%;
                }
            }
        }

        .filter-category,
        .filter-type,
        .sort {
            width: calc(33.33% - 12px);
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            margin-bottom: 20px;

            @media only screen and (max-width: 659px) {
                width: 100%;
            }
        }
    }

    .featured {
        //max-width: 1300px;
        width: 100%;
        margin: auto;
        background-color: #242424;
        padding-top: 20px;
        padding-bottom: 20px;
        margin-bottom: 40px;
        overflow: hidden;
        position: relative;

        .flexslider .flex-direction-nav .flex-next,
        .flexslider .flex-direction-nav .flex-prev {
            //opacity: 1;
            line-height: normal;
            background: #ffffff;
            border-radius: 100%;
            padding: 30px 20px;
            width: 100px;
            height: 100px;
            color: #ffffff;
            transform: translate(0, -50%);
            margin: 0;
        }

        .flexslider .flex-direction-nav .flex-next {
            right: -49px;
            text-align: left;
        }

        .flexslider .flex-direction-nav .flex-prev {
            left: -49px;
            text-align: right;
        }

        .flexslider {
            max-width: 1320px;
            width: 100%;
            margin: auto;
            border-radius: 0;
            border: none;
            background: transparent;
            position: static !important;

            .flex-viewport {
                overflow: visible !important;
                position: static !important;
            }

            ul {
                display: flex;
                li {
                    margin: 0;

                    .card-container {
                        height: 100%;
                        display: flex;
                        padding: 20px 10px;

                        @media only screen and (max-width: 999px) {
                            flex-direction: column;
                        }

                        .meta {
                            width: 50%;
                            padding: 12px 20px;
                            background-color: #ffffff;
                            border-radius: 15px 0 0 15px;
                            border-right-width: 4px;
                            border-right-style: solid;

                            @media only screen and (max-width: 999px) {
                                width: 100%;
                                max-width: 474px;
                                border-radius: 15px 15px 0 0;
                                border-bottom-width: 4px;
                                border-bottom-style: solid;
                                border-right: none;
                            }

                            .category {
                                text-align: center;
                                font-weight: 600;
                                font-size: 18px;
                                line-height: 1.5;
                            }

                            .photo {
                                margin-bottom: 6px;

                                img {
                                    width: 100%;
                                }
                            }

                            .name {
                                font-weight: bold;
                                font-size: 18px;
                                line-height: 1.5;
                                text-align: center;
                                margin-bottom: 6px;
                            }

                            .company-logo {
                                margin: 12px auto;
                                display: flex;
                                justify-content: center;

                                a {
                                    display: inline-block;

                                    img {
                                        width: auto;
                                        max-height: 70px;
                                        display: inline-block;
                                    }
                                }
                            }

                            .company {
                                text-align: center;

                                a {
                                    font-size: 14px;
                                    line-height: 18px;
                                    color: #737373;
                                    margin-bottom: 6px;
                                    text-decoration: none;
                                }
                            }

                            p.company-description {
                                font-size: 12px;
                                line-height: 1.5;
                            }
                        }

                        .description {
                            width: 50%;
                            padding: 12px 20px;
                            background: linear-gradient(200.12deg, #f3f3f3 0%, #b9b9b9 100%);
                            border-radius: 0 15px 15px 0;

                            @media only screen and (max-width: 999px) {
                                width: 100%;
                                max-width: 474px;
                                border-radius: 0 0 15px 15px;
                            }

                            .announcement {
                                text-align: center;
                                font-weight: bold;
                                font-size: 18px;
                                line-height: 1.5;
                                color: #464646;
                                margin-bottom: 6px;
                            }

                            .title {
                                font-weight: 600;
                                font-size: 14px;
                                line-height: 1.5;
                                color: #737373;
                                text-align: center;
                                margin-bottom: 20px;
                            }

                            p {
                                font-family: "Inter", sans-serif;
                                font-size: 14px;
                                line-height: 1.5;
                            }
                        }
                    }
                }
            }
        }
    }

    .standard {
        max-width: 1370px;
        margin: auto;
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        grid-template-rows: repeat(auto-fill, 1fr);
        grid-column-gap: 20px;
        grid-row-gap: 20px;
        padding: 0 35px;

        @media only screen and (max-width: 1279px) {
            grid-template-columns: repeat(3, 1fr);
        }

        @media only screen and (max-width: 999px) {
            grid-template-columns: repeat(2, 1fr);
        }

        @media only screen and (max-width: 775px) {
            padding: 0 15px;
        }

        @media only screen and (max-width: 606px) {
            grid-template-columns: repeat(1, 1fr);
        }

        .ibjp-card {
            display: flex;
            flex-direction: column;
            background-color: #ededed;
            border-radius: 15px;
            justify-content: space-between;
            box-shadow: 0px 3px 3px rgba(0, 0, 0, 0.5);
            border: none;

            .card-padding {
                padding: 6px 20px 20px 20px;
            }

            .category {
                text-align: center;
                font-weight: 600;
                font-size: 18px;
                line-height: 1.5;
            }

            .photo {
                margin-bottom: 6px;

                img {
                    width: 100%;
                }
            }

            .name {
                font-weight: bold;
                font-size: 18px;
                line-height: 1.5;
                text-align: center;
                margin-bottom: 6px;
            }

            .description {
                margin-bottom: 6px;

                p {
                    font-family: "Inter", sans-serif;
                    font-size: 14px;
                    line-height: 1.5;
                }
            }

            .company {
                font-size: 14px;
                line-height: 1.5;
                color: #737373;
                text-align: center;
            }

            .meta {
                background: url(@/assets/background.png), linear-gradient(200.12deg, #dddddd 0%, #bbbbbb 100%);
                background-repeat: no-repeat;
                background-position: top, right;
                background-size: cover;
                border-radius: 0px 0px 15px 15px;
                border-top-width: 4px;
                border-top-style: solid;
                padding: 6px 20px 20px 20px;
                min-height: 94px;

                .announcement {
                    text-align: center;
                    font-weight: bold;
                    font-size: 18px;
                    line-height: 1.5;
                    color: #464646;
                    margin-bottom: 6px;
                }

                .title {
                    font-weight: 600;
                    font-size: 14px;
                    line-height: 1.5;
                    color: #737373;
                    text-align: center;
                }
            }
        }
    }

    .accounting {
        .category {
            color: #215c3a;
        }

        .meta {
            border-color: #215c3a;
        }
    }

    .advertising {
        .category {
            color: #b730d2;
        }

        .meta {
            border-color: #b730d2;
        }
    }

    .architecture {
        .category {
            color: #53966f;
        }

        .meta {
            border-color: #53966f;
        }
    }

    .banking {
        .category {
            color: #bf0413;
        }

        .meta {
            border-color: #bf0413;
        }
    }

    .bar-association {
        .category {
            color: #215c3a;
        }

        .meta {
            border-color: #215c3a;
        }
    }

    .business {
        .category {
            color: #215c3a;
        }

        .meta {
            border-color: #215c3a;
        }
    }

    .civic-not-for-profit {
        .category {
            color: #09528d;
        }

        .meta {
            border-color: #09528d;
        }
    }

    .construction {
        .category {
            color: #e59d32;
        }

        .meta {
            border-color: #e59d32;
        }
    }

    .design {
        .category {
            color: #077774;
        }

        .meta {
            border-color: #077774;
        }
    }

    .education {
        .category {
            color: #922758;
        }

        .meta {
            border-color: #922758;
        }
    }

    .engineering {
        .category {
            color: #63979f;
        }

        .meta {
            border-color: #63979f;
        }
    }

    .finance {
        .category {
            color: #1c900b;
        }

        .meta {
            border-color: #1c900b;
        }
    }

    .government {
        .category {
            color: #1d7d5a;
        }

        .meta {
            border-color: #1d7d5a;
        }
    }

    .health-care {
        .category {
            color: #215c3a;
        }

        .meta {
            border-color: #215c3a;
        }
    }

    .hospitality {
        .category {
            color: #ad7f12;
        }

        .meta {
            border-color: #ad7f12;
        }
    }

    .in-house-counsel {
        .category {
            color: #215c3a;
        }

        .meta {
            border-color: #215c3a;
        }
    }

    .insurance {
        .category {
            color: #2d526f;
        }

        .meta {
            border-color: #2d526f;
        }
    }

    .law {
        .category {
            color: #c00e43;
        }

        .meta {
            border-color: #c00e43;
        }
    }

    .law-firm {
        .category {
            color: #215c3a;
        }

        .meta {
            border-color: #215c3a;
        }
    }

    .law-school {
        .category {
            color: #215c3a;
        }

        .meta {
            border-color: #215c3a;
        }
    }

    .legal-aid {
        .category {
            color: #215c3a;
        }

        .meta {
            border-color: #215c3a;
        }
    }

    .logistics {
        .category {
            color: #8898af;
        }

        .meta {
            border-color: #8898af;
        }
    }

    .manufacturing {
        .category {
            color: #517ab8;
        }

        .meta {
            border-color: #517ab8;
        }
    }

    .marketing {
        .category {
            color: #ff7a00;
        }

        .meta {
            border-color: #ff7a00;
        }
    }

    .media {
        .category {
            color: #b91700;
        }

        .meta {
            border-color: #b91700;
        }
    }

    .not-for-profit {
        .category {
            color: #215c3a;
        }

        .meta {
            border-color: #215c3a;
        }
    }

    .printing-publishing {
        .category {
            color: #023480;
        }

        .meta {
            border-color: #023480;
        }
    }

    .professional-trade {
        .category {
            color: #3ca8da;
        }

        .meta {
            border-color: #3ca8da;
        }
    }

    .public-relations {
        .category {
            color: #73a80c;
        }

        .meta {
            border-color: #73a80c;
        }
    }

    .publishing {
        .category {
            color: #215c3a;
        }

        .meta {
            border-color: #215c3a;
        }
    }

    .real-estate {
        .category {
            color: #ba574d;
        }

        .meta {
            border-color: #ba574d;
        }
    }

    .restaurants {
        .category {
            color: #565858;
        }

        .meta {
            border-color: #565858;
        }
    }

    .retail {
        .category {
            color: #ab6c1a;
        }

        .meta {
            border-color: #ab6c1a;
        }
    }

    .services {
        .category {
            color: #7c827f;
        }

        .meta {
            border-color: #7c827f;
        }
    }

    .sports {
        .category {
            color: #e20000;
        }

        .meta {
            border-color: #e20000;
        }
    }

    .technology {
        .category {
            color: #2c6f90;
        }

        .meta {
            border-color: #2c6f90;
        }
    }

    .telecommunications {
        .category {
            color: #64a8a4;
        }

        .meta {
            border-color: #64a8a4;
        }
    }

    .tourism {
        .category {
            color: #118a23;
        }

        .meta {
            border-color: #118a23;
        }
    }

    .transportation {
        .category {
            color: #585fb8;
        }

        .meta {
            border-color: #585fb8;
        }
    }

    .utilities {
        .category {
            color: #1242a0;
        }

        .meta {
            border-color: #1242a0;
        }
    }

    .wholesale {
        .category {
            color: #9b6ad9;
        }

        .meta {
            border-color: #9b6ad9;
        }
    }
}
</style>
